module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pdf-forms/auctionnotification/auctionnotification.component.css
// module id = ./src/app/pdf-forms/auctionnotification/auctionnotification.component.css
// module chunks = main